import React, { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { useThemeStore } from '../stores/themeStore';
import { useUserStore } from '../stores/userStore';
import { useSidebarStore } from '../stores/sidebarStore';
import { useProjectStore } from '../stores/projectStore';
import { useReportStore } from '../stores/reportStore';
import { useNotificationStore } from '../stores/notificationStore';
import { useSettingsStore } from '../stores/settingsStore';

interface StoreProviderProps {
  children: React.ReactNode;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  // Initialize stores
  const { loadThemes } = useThemeStore();
  const { generateMockReports } = useReportStore();
  const { addNotification } = useNotificationStore();

  useEffect(() => {
    // Initialize theme store
    loadThemes();
    
    // Generate mock data for development
    if (process.env.NODE_ENV === 'development') {
      generateMockReports();
      
      // Add welcome notification
      addNotification({
        type: 'info',
        title: 'Welcome!',
        message: 'Zustand stores and React Query have been initialized successfully.',
      });
    }
  }, [loadThemes, generateMockReports, addNotification]);

  return <>{children}</>;
};


